interface sliceRoutes {
  [key: string]: string;
}

export enum statusEnum {
  pending = "pending",
  succeeded = "succeeded",
  failed = "failed",
  idle = "idle",
  loading = "loading",
}


export const addressRoutes: sliceRoutes = {
  searchAddress: "/v2/autocomplete"
};

export const propertyRoutes: sliceRoutes = {
  property: "/properties",
  dataset: "/datasets",
  documentImageView: "/DS/DocumentSearch/DocumentImageView",
  documentDetailView: "/DS/DocumentSearch/DocumentDetail",
  OverviewForComplaintServlet: '/bisweb/OverviewForComplaintServlet',
  actionViolationDisplayServlet: '/bisweb/OverviewForComplaintServlet',
  ecbQueryByNumberServlet: '/bisweb/ECBQueryByNumberServlet',
  jobsQueryByNumberServlet: '/bisweb/JobsQueryByNumberServlet'
}

export const authRoutes: sliceRoutes = {
  LOGIN: "/auth/login",
  SIGNUP: "/auth/signup",
  FORGOT_PASSWORD: "/auth/forgot-password",
  CONTACT_US: "/contact-us",
}

export const userRoutes: sliceRoutes = {
  ADD_PROPERTY_BOOKMARK: "/user/add-property-bookmark",
  REMOVE_PROPERTY_BOOKMARK: "/user/remove-property-bookmark",
  ADD_CUSTOM_BOOKMARK: "/user/add-custom-bookmark",
  REMOVE_CUSTOM_BOOKMARK: "/user/remove-custom-bookmark",
  EDIT_CUSTOM_BOOKMARK: "/user/edit-custom-bookmark",
  GET_PROPERTY_BOOKMARK: "/user/get-property-bookmark",
  GET_CUSTOM_BOOKMARK: "/user/get-custom-bookmark",
}